import Route from '@ember/routing/route';

export default class CoachingCoachIndexRoute extends Route {}
